<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row" v-if="userData.permissions['report_cards'] == 1">
      <div class="row">
        <div class="col-12">
          <div class="card shadow-lg">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-center">
                <div class="fw-medium text-success">
                  Note: The latest Comment Group applies to the report.
                </div>
              </div>
              <div class="d-flex justify-content-end gap-2">
                <div>
                  <b-button
                    size="sm"
                    variant="success"
                    @click.prevent="
                      $bvModal.show('add-comment-group');
                      toggleAddFormWizard();
                    "
                    ><i class="mdi mdi-plus"></i> Comment Group</b-button
                  >
                </div>
              </div>
              <div class="my-2"></div>
              <div class="clearfix"></div>
              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                      Show
                      <b-form-select
                        class="form-select form-select-sm mx-1"
                        v-model="perPage"
                        size="sm"
                        :options="Options"
                      ></b-form-select>
                      entries
                    </label>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6">
                  <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                  >
                    <label class="d-inline-flex align-items-center">
                      Search:
                      <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ms-2"
                      ></b-form-input>
                    </label>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <b-table
                  :items="Items"
                  :fields="Fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="Filtered"
                  :busy="IsBusy"
                >
                  <template #table-busy>
                    <div class="text-center text-primary my-2">
                      <b-spinner
                        class="align-middle"
                        type="grow"
                        small
                      ></b-spinner>
                      <strong>No Data</strong>
                    </div>
                  </template>
                  <template #cell(index)="data">
                    {{ data.index + 1 }}
                  </template>

                  <template #cell(class)="data">
                    {{ data.item.class }}
                    <small
                      v-if="data.item.stream"
                      class="d-block text-primary fw-medium"
                      >Stream: {{ data.item.stream }}</small
                    >
                  </template>

                  <template #cell(status)="data">
                    <span
                      v-if="data.item.status == 1"
                      class="badge text-white bg-primary"
                      >Class Teacher</span
                    >
                    <span
                      v-if="data.item.status == 2"
                      class="badge text-white bg-success"
                      >Head Teacher</span
                    >
                  </template>

                  <template #cell(actions)="data">
                    <button
                      @click.prevent="
                        preview(
                          data.item.id,
                          data.item.class,
                          data.item.stream,
                          data.item.status,
                        )
                      "
                      class="btn btn-sm btn-info"
                    >
                      <i class="mdi mdi-eye"></i>
                    </button>
                    <button
                      @click.prevent="
                        editModal = true;
                        edit(
                          data.item.id,
                          data.item.class_id,
                          data.item.stream_id,
                          data.item.status,
                        );
                      "
                      class="btn btn-sm btn-primary"
                    >
                      <i class="mdi mdi-pencil"></i>
                    </button>
                    <button
                      @click.prevent="
                        remove(data.item.id, data.item.class, data.item.stream)
                      "
                      class="btn btn-sm btn-danger"
                    >
                      <i class="mdi mdi-trash-can"></i>
                    </button>
                  </template>
                </b-table>
              </div>
              <div class="row">
                <div class="col">
                  <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                  >
                    <ul class="pagination pagination-rounded mb-0">
                      <b-pagination
                        v-model="currentPage"
                        :total-rows="List"
                        :per-page="perPage"
                      ></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <b-modal
        id="add-comment-group"
        size=""
        centered
        :title="`${editModal ? 'Edit' : 'New'} Comment Group for ${commentor}`"
        hide-footer
      >
        <div class="text-center" v-if="loader">
          <b-spinner class="text-primary" small></b-spinner>
          <p class="fw-medium text-primary">Loading...</p>
        </div>
        <div v-else class="">
          <form-wizard
            v-if="showWizard"
            :start-index="0"
            @on-complete="editModal ? editCommentGroup() : addCommentGroup()"
            shape="pill"
            back-button-text="Back"
            next-button-text="Next"
            :finish-button-text="editModal ? `Edit` : `Submit`"
            color="#ef2c01"
          >
            <tab-content
              title="Comment Group"
              icon="mdi mdi-text-box-plus"
              :before-change="validateAdminTab1"
            >
              <label class="fw-medium mb-1">Comment Group for:</label>
              <div v-show="status != 1" class="justify-content-start mb-3">
                <button
                  @click.prevent="selectedButton = 2"
                  v-show="status == 3 || status == 2"
                  class="btn mx-1"
                  :class="{
                    'btn-dark': selectedButton == 2,
                    'btn-sm btn-outline-primary': selectedButton != 2,
                  }"
                >
                  Head Teacher
                </button>
                <button
                  @click.prevent="selectedButton = 1"
                  v-show="status == 3 || status == 1"
                  class="btn mx-1"
                  :class="{
                    'btn-dark': selectedButton == 1,
                    'btn-sm btn-outline-primary': selectedButton != 1,
                  }"
                >
                  Class Teacher
                </button>
                <small
                  v-if="selectedButton == 2"
                  class="mt-2 d-block text-primary fw-medium"
                  >Add Comment Groups for a class as an Head Teacher</small
                >
                <small
                  v-if="selectedButton == 1"
                  class="mt-2 d-block text-primary fw-medium"
                  >Add Comment Groups for the stream as a Class Teacher</small
                >
              </div>
              <hr />
              <div class="row">
                <div class="col-12 mb-2">
                  <label class="mb-0" for="class">Class</label>
                  <v-select
                    placeholder="Choose Class"
                    label="name"
                    :options="schoolclasses"
                    v-model="school_class"
                    @input="onClassChange"
                  ></v-select>
                  <span class="text-danger" v-if="school_class_error">{{
                    school_class_error
                  }}</span>
                </div>
                <div class="col-12" v-show="selectedButton == 1">
                  <label class="mb-0" for="class">Stream</label>
                  <v-select
                    placeholder="Choose Class"
                    label="name"
                    :options="class_streams"
                    v-model="class_stream"
                  ></v-select>
                  <span class="text-danger" v-if="class_stream_error">{{
                    class_stream_error
                  }}</span>
                </div>

                <div class="col-12 mb-2">
                  <label class="mb-0" for="class">Signature</label>
                  <input
                    id="signature"
                    type="file"
                    accept="application"
                    class="form-control"
                    @change="handleImage"
                  />
                </div>
              </div>
            </tab-content>

            <tab-content
              title="Group Details"
              icon="mdi mdi-comment-text-outline"
              :before-change="validateAdminTab2"
            >
              <div class="row">
                <div class="col-5">
                  <div class="row">
                    <div class="col-6">From</div>
                    <div class="col-6">To</div>
                    <hr />

                    <!-- Range 1 -->
                    <div class="col-6">
                      <input
                        type="number"
                        readonly
                        class="text-primary fw-medium form-control my-1"
                        v-model="start_1"
                      />
                    </div>
                    <div class="col-6">
                      <input
                        type="number"
                        @change="start_2 = nextRange(end_1)"
                        class="text-primary fw-medium form-control my-1"
                        :class="{
                          'is-invalid': end_1 < start_1 && end_1 != '',
                        }"
                        v-model="end_1"
                      />
                    </div>

                    <!-- Range 2 -->
                    <div class="col-6">
                      <input
                        type="number"
                        readonly
                        class="text-primary fw-medium form-control my-1"
                        v-model="start_2"
                      />
                    </div>
                    <div class="col-6">
                      <input
                        type="number"
                        @change="start_3 = nextRange(end_2)"
                        class="text-primary fw-medium form-control my-1"
                        :class="{
                          'is-invalid': end_2 < start_2 && end_2 != '',
                        }"
                        v-model="end_2"
                      />
                    </div>

                    <!-- Range 3 -->
                    <div class="col-6">
                      <input
                        type="number"
                        readonly
                        class="text-primary fw-medium form-control my-1"
                        v-model="start_3"
                      />
                    </div>
                    <div class="col-6">
                      <input
                        type="number"
                        @change="start_4 = nextRange(end_3)"
                        class="text-primary fw-medium form-control my-1"
                        :class="{
                          'is-invalid': end_3 < start_3 && end_3 != '',
                        }"
                        v-model="end_3"
                      />
                    </div>

                    <!-- Range 4 -->
                    <div class="col-6">
                      <input
                        type="number"
                        readonly
                        class="text-primary fw-medium form-control my-1"
                        v-model="start_4"
                      />
                    </div>
                    <div class="col-6">
                      <input
                        type="number"
                        @change="start_5 = nextRange(end_4)"
                        class="text-primary fw-medium form-control my-1"
                        :class="{
                          'is-invalid': end_4 < start_4 && end_4 != '',
                        }"
                        v-model="end_4"
                      />
                    </div>

                    <!-- Range 5 -->
                    <div class="col-6">
                      <input
                        type="number"
                        readonly
                        class="text-primary fw-medium form-control my-1"
                        v-model="start_5"
                      />
                    </div>
                    <div class="col-6">
                      <input
                        type="number"
                        class="text-primary fw-medium form-control my-1"
                        :class="{
                          'is-invalid': end_5 < start_5 && end_5 != '',
                        }"
                        v-model="end_5"
                      />
                    </div>
                    <br />
                    <hr />
                  </div>
                </div>
                <div class="col-7">
                  <div class="row">
                    <div class="">Comment</div>
                    <hr />
                    <input
                      class="form-control my-1"
                      v-model="comment_1"
                      placeholder="Enter comment here..."
                    />
                    <input
                      class="form-control my-1"
                      v-model="comment_2"
                      placeholder="Enter comment here..."
                    />
                    <input
                      class="form-control my-1"
                      v-model="comment_3"
                      placeholder="Enter comment here..."
                    />
                    <input
                      class="form-control my-1"
                      v-model="comment_4"
                      placeholder="Enter comment here..."
                    />
                    <input
                      class="form-control my-1"
                      v-model="comment_5"
                      placeholder="Enter comment here..."
                    />
                    <br />
                    <hr />
                  </div>
                </div>
              </div>
              <div class="container-fuild">
                <div>Ungraded</div>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Enter comment here..."
                  v-model="comment_6"
                />
              </div>
              <small class="fw-medium text-danger" v-if="range_error">{{
                range_error
              }}</small>
            </tab-content>

            <tab-content title="Preview" icon="mdi mdi-eye">
              <div class="row">
                <div class="col-12">
                  <h5>Class: {{ school_class ? school_class.name : "" }}</h5>
                  <h6 v-if="selectedButton == 1" class="text-primary">
                    Stream: {{ class_stream ? class_stream.name : "" }}
                  </h6>
                  <hr />
                  <div class="row">
                    <div class="col-5">
                      <div class="row">
                        <div class="col-6 my-1 fw-medium">From</div>
                        <div class="col-6 my-1 fw-medium">To</div>
                        <hr />

                        <!-- Range 1 -->
                        <div v-if="end_1 !== ''" class="col-6 my-1">
                          {{ start_1 }}
                        </div>
                        <div v-if="end_1 !== ''" class="col-6 my-1">
                          {{ end_1 }}
                        </div>

                        <!-- Range 2 -->
                        <div v-if="end_2 !== ''" class="col-6 my-1">
                          {{ start_2 }}
                        </div>
                        <div v-if="end_2 !== ''" class="col-6 my-1">
                          {{ end_2 }}
                        </div>

                        <!-- Range 3 -->
                        <div v-if="end_3 !== ''" class="col-6 my-1">
                          {{ start_3 }}
                        </div>
                        <div v-if="end_3 !== ''" class="col-6 my-1">
                          {{ end_3 }}
                        </div>

                        <!-- Range 4 -->
                        <div v-if="end_4 !== ''" class="col-6 my-1">
                          {{ start_4 }}
                        </div>
                        <div v-if="end_4 !== ''" class="col-6 my-1">
                          {{ end_4 }}
                        </div>

                        <!-- Range 5 -->
                        <div v-if="end_5 !== ''" class="col-6 my-1">
                          {{ start_5 }}
                        </div>
                        <div v-if="end_5 !== ''" class="col-6 my-1">
                          {{ end_5 }}
                        </div>
                      </div>
                    </div>
                    <div class="col-7">
                      <div class="row">
                        <div class="col-6 my-1 fw-medium">Comment</div>
                        <hr />

                        <div v-if="end_1 != ''" class="my-1">
                          {{ comment_1 }}
                        </div>
                        <div v-if="end_2 != ''" class="my-1">
                          {{ comment_2 }}
                        </div>
                        <div v-if="end_3 != ''" class="my-1">
                          {{ comment_3 }}
                        </div>
                        <div v-if="end_4 != ''" class="my-1">
                          {{ comment_4 }}
                        </div>
                        <div v-if="end_5 != ''" class="my-1">
                          {{ comment_5 }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <br />
                  <span v-if="comment_6">Ungraded: {{ comment_6 }}</span>
                </div>
                <hr />
              </div>
            </tab-content>
          </form-wizard>
        </div>
      </b-modal>

      <b-modal
        id="delete-comment-group"
        centered
        title="Delete Comment Group"
        hide-footer
      >
        <div class="text-center">
          <p class="fw-medium mb-3">
            Are you sure you want to delete this comment group?
          </p>
          <b-button
            variant="danger"
            class="mx-2"
            @click="confirmDeleteCommentGroup"
            >Delete</b-button
          >
          <b-button
            variant="secondary"
            class="mx-2"
            @click="$bvModal.hide('delete-comment-group')"
            >Cancel</b-button
          >
        </div>
      </b-modal>

      <b-modal
        id="preview-comment-group"
        centered
        title="Preview Comment Group"
        hide-footer
      >
        <div v-if="previewGroup">
          <h5>Class: {{ school_class }}</h5>
          <h6 v-if="class_stream" class="text-primary">
            Stream: {{ class_stream }}
          </h6>
          <span class="me-2 text-primary fw-medium">Type:</span
          ><span v-if="status == 1" class="badge text-white bg-primary">
            Class Teacher</span
          >
          <span v-if="status == 2" class="badge text-white bg-success">
            Head Teacher</span
          >
          <hr />
          <div class="row">
            <div class="col-5">
              <div class="row">
                <div class="col-6 fw-bold">From</div>
                <div class="col-6 fw-bold">To</div>
              </div>
              <hr />
              <div
                class="row"
                v-for="(detail, idx) in previewGroup.details.filter(
                  (d) => d.start_agg !== 0 || d.end_agg !== 0,
                )"
                :key="idx"
              >
                <div class="col-6 my-1">{{ detail.start_agg }}</div>
                <div class="col-6 my-1">{{ detail.end_agg }}</div>
              </div>
            </div>
            <div class="col-7">
              <div class="row">
                <div class="col-6 fw-bold">Comment</div>
              </div>
              <hr />
              <div
                class="row"
                v-for="(detail, idx) in previewGroup.details.filter(
                  (d) => d.start_agg != 0 || d.end_agg != 0,
                )"
                :key="idx + '_c'"
              >
                <div class="col-6 my-1">{{ detail.comment }}</div>
              </div>
            </div>
          </div>
          <br />
          <span
            v-if="
              previewGroup.details.find(
                (d) => d.start_agg == 0 && d.end_agg == 0,
              )
            "
          >
            Ungraded:
            {{
              previewGroup.details.find(
                (d) => d.start_agg == 0 && d.end_agg == 0,
              ).comment
            }}
          </span>
        </div>
        <div v-else>
          <b-spinner class="text-primary" small></b-spinner>
          <p class="fw-medium text-primary">Loading...</p>
        </div>
      </b-modal>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <center>
              <span class="text-primary h4"
                >You have no permission to view the Dashboard.</span
              >
            </center>
            <img
              src="@/assets/images/profile-img.png"
              alt
              class="img-fluid"
            /><br /><br />
          </div>
        </div>
      </div>
    </div>

    <!-- </div>
  </div> -->
  </Layout>
</template>

<script>
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import {
  commentgroupsComputed,
  commentgroupsMethods,
  schoolclassComputed,
  schoolclassMethods,
} from "@/state/helpers";
import axios from "axios";
import Layout from "../../layouts/main";

export default {
  page: {
    title: "General Comments",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "General Report Comments",
      items: [
        { text: "Dashboard", to: "/" },
        { text: "General Report Comments", active: true },
      ],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
        { key: "index", label: "#", visible: true },
        { key: "id", label: "ID", visible: false },
        { key: "class", label: "Class", visible: true },
        {
          key: "status",
          label: "Type",
          visible:
            JSON.parse(localStorage.getItem("user")).permissions
              .set_admin_comments &
            JSON.parse(localStorage.getItem("user")).permissions
              .set_classteacher_comments,
        },
        { key: "created_at", label: "Added on", visible: true },
        { key: "actions", label: "Actions", visible: true },
      ],

      showWizard: false,
      status: 0,
      signature: "",
      selectedButton: 0, // Determines what status to save in the comments table
      /*
      A - Admin   C - ClassTeacher
      A C
      0 1 - 1
      1 0 - 2
      1 1 - 3
      */
      start_1: 4,
      start_2: "",
      start_3: "",
      start_4: "",
      start_5: "",
      end_1: "",
      end_2: "",
      end_3: "",
      end_4: "",
      end_5: "",
      comment_1: "",
      comment_2: "",
      comment_3: "",
      comment_4: "",
      comment_5: "",
      comment_6: "",

      previewGroup: null,
      school_class: "",
      class_stream: "",
      class_streams: [],
      school_class_error: "",
      class_stream_error: "",
      range_error: "",
      loader: false,
      editModal: false,
      id: "",
      detail_ids: [],
    };
  },

  computed: {
    ...commentgroupsComputed,
    ...schoolclassComputed,
    List() {
      return this.commentgroups.length;
    },
    Fields() {
      return this.fields.filter((field) => field.visible);
    },
    Items() {
      return this.commentgroups.map((d) => ({ ...d }));
    },
    IsBusy() {
      let a = false;
      if (this.commentgroups.length > 0) {
        a = false;
      } else {
        a = true;
      }
      return a;
    },

    commentor() {
      if (this.selectedButton == 1) {
        return "Class Teacher";
      } else if (this.selectedButton == 2) {
        return "Head Teacher";
      } else {
        return "Unknown";
      }
    },
  },

  mounted() {
    this.setStatus();
    this.fetchCommentGroups();
    this.fetchSchoolClasses();
  },

  methods: {
    ...commentgroupsMethods,
    ...schoolclassMethods,
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    setStatus() {
      const admin_permission = this.userData.permissions.set_admin_comments;
      const classteacher_permission = this.userData.permissions
        .set_classteacher_comments;

      if (admin_permission == 1 && classteacher_permission == 1) {
        // 11: Both permissions
        this.status = 3;
        this.selectedButton = 2; // Default to Admin
      } else if (admin_permission == 1 && classteacher_permission == 0) {
        // 10: Only admin
        this.status = 2;
        this.selectedButton = 2;
      } else if (admin_permission == 0 && classteacher_permission == 1) {
        // 01: Only class teacher
        this.status = 1;
        this.selectedButton = 1;
      }
    },

    nextRange(start) {
      return Number(start) + 1;
    },

    toggleAddFormWizard() {
      // Form Wizard fails to reset to default tab. this solves it
      this.showWizard = false;
      this.showWizard = true;
      this.editModal = false;
      this.loader = false;
    },

    toggleEditFormWizard() {
      // Form Wizard fails to reset to default tab. this solves it
      this.showWizard = false;
      this.showWizard = true;
      this.editModal = true;
      this.loader = true;
    },

    onClassChange() {
      this.class_stream = null; // Reset class stream when class changes
      if (!this.school_class) return;
      axios
        .get(`/findschoolstream/${this.school_class.id}`)
        .then((response) => {
          if (response.status === 200) {
            this.class_streams = response.data.streams;
          } else {
            this.$swal({
              title: "Error",
              text: "Failed to fetch streams.",
              icon: "error",
            });
          }
        })
        .catch(() => {
          this.$swal({
            title: "Error",
            text: "Failed to fetch streams.",
            icon: "error",
          });
        });
    },

    validateAdminTab1() {
      let valid = true;

      // Validate class
      if (
        !this.school_class ||
        typeof this.school_class !== "object" ||
        !this.school_class.id
      ) {
        this.school_class_error = "Class is required";
        valid = false;
      } else {
        this.school_class_error = "";
      }

      // Validate stream only if Class Teacher is selected
      if (this.selectedButton == 1) {
        if (
          !this.class_stream ||
          typeof this.class_stream !== "object" ||
          !this.class_stream.id
        ) {
          this.class_stream_error = "Stream is required";
          valid = false;
        } else {
          this.class_stream_error = "";
        }
      } else {
        this.class_stream_error = "";
      }

      return valid;
    },

    validateAdminTab2() {
      const ranges = [
        { start: this.start_1, end: this.end_1 },
        { start: this.start_2, end: this.end_2 },
        { start: this.start_3, end: this.end_3 },
        { start: this.start_4, end: this.end_4 },
        { start: this.start_5, end: this.end_5 },
      ];

      for (let i = 0; i < ranges.length; i++) {
        if (
          ranges[i].end !== "" &&
          ranges[i].start !== "" &&
          Number(ranges[i].end) < Number(ranges[i].start)
        ) {
          this.range_error = `End value for range ${i +
            1} cannot be less than start value.`;
          return false;
        }
      }
      this.range_error = ""; // Clear any previous error
      return true;
    },

    async preview(id, school_class, stream, status) {
      this.loader = true;
      this.id = id;
      this.school_class = school_class;
      this.class_stream = stream;
      this.status = status;
      try {
        const response = await axios.get(`/comment-group-details/${id}`);
        if (response.status === 200) {
          this.previewGroup = response.data;
          this.$bvModal.show("preview-comment-group");
        } else {
          this.$swal({
            title: "Error",
            text: "Failed to fetch comment group details.",
            icon: "error",
          });
        }
      } catch (error) {
        this.$swal({
          title: "Error",
          text: "Failed to fetch comment group details. Please try again.",
          icon: "error",
        });
      } finally {
        this.loader = false;
      }
    },

    async edit(id, school_class, stream, status) {
      this.$bvModal.show("add-comment-group");
      this.toggleEditFormWizard();
      this.id = id;
      this.selectedButton = status; // Set the selected button based on the status
      this.school_class =
        this.schoolclasses.find((cls) => cls.id === school_class) || null;
      const [, response] = await Promise.all([
        this.onClassChange(), // First async operation
        axios.get(`/comment-group-details/${id}`), // Second async operation
      ]);
      this.class_stream =
        this.class_streams.find((str) => str.id === stream) || null;

      this.detail_ids = [];
      if (response.status == 200) {
        const data = response.data.details;
        this.start_1 = data[0].start_agg;
        this.end_1 = data[0].end_agg;
        this.comment_1 = data[0].comment;

        if (data.length > 1) {
          this.start_2 = data[1].start_agg;
          this.end_2 = data[1].end_agg;
          this.comment_2 = data[1].comment;
        } else {
          this.start_2 = this.nextRange(this.end_1); // Set next range if only one range exists
          this.loader = false;
          return; // Exit early if only one range exists
        }

        if (data.length > 2) {
          this.start_3 = data[2].start_agg;
          this.end_3 = data[2].end_agg;
          this.comment_3 = data[2].comment;
        } else {
          this.start_3 = this.nextRange(this.end_2); // Set next range if only two ranges exist
          this.loader = false;
          return; // Exit early if only two ranges exist
        }

        if (data.length > 3) {
          this.start_4 = data[3].start_agg;
          this.end_4 = data[3].end_agg;
          this.comment_4 = data[3].comment;
        } else {
          this.start_4 = this.nextRange(this.end_3); // Set next range if only three ranges exist
          this.loader = false;
          return; // Exit early if only three ranges exist
        }

        if (data.length > 4) {
          this.start_5 = data[4].start_agg;
          this.end_5 = data[4].end_agg;
          this.comment_5 = data[4].comment;
        } else {
          this.start_5 = this.nextRange(this.end_4); // Set next range if only four ranges exist
          this.loader = false;
          return; // Exit early if only four ranges exist
        }

        if (data.length > 5) {
          this.comment_6 = data[5].comment; // Ungraded comment
        }

        this.loader = false;
      } else {
        this.$swal({
          title: "Error",
          text: "Failed to fetch comment group details.",
          icon: "error",
        });
        this.loader = false;
      }
    },

    remove(id, school_class, stream) {
      this.id = id;
      this.school_class = school_class;
      this.class_stream = stream;
      this.$bvModal.show("delete-comment-group");
    },

    // async addCommentGroup() {

    //   const obj = {
    //     signature: this.signature,
    //     school_class: this.school_class.id,
    //     ...(this.selectedButton == 1 && this.class_stream && this.class_stream.id ? { stream: this.class_stream.id } : {}),
    //     status: this.selectedButton,
    //     comments: [
    //       ...(this.start_1 !== '' && this.end_1 !== '' ? [{ start_agg: Number(this.start_1), end_agg: Number(this.end_1), comment: this.comment_1 }] : []),
    //       ...(this.start_2 !== '' && this.end_2 !== '' ? [{ start_agg: Number(this.start_2), end_agg: Number(this.end_2), comment: this.comment_2 }] : []),
    //       ...(this.start_3 !== '' && this.end_3 !== '' ? [{ start_agg: Number(this.start_3), end_agg: Number(this.end_3), comment: this.comment_3 }] : []),
    //       ...(this.start_4 !== '' && this.end_4 !== '' ? [{ start_agg: Number(this.start_4), end_agg: Number(this.end_4), comment: this.comment_4 }] : []),
    //       ...(this.start_5 !== '' && this.end_5 !== '' ? [{ start_agg: Number(this.start_5), end_agg: Number(this.end_5), comment: this.comment_5 }] : []),
    //       ...(this.comment_6 ? [{ start_agg: 0, end_agg: 0, comment: this.comment_6 }] : []),
    //     ]
    //   };

    //   try {
    //     const response = await axios.post("/add-comment-group", obj);

    //     if (response.status == 409) {
    //       this.$swal({ title: 'Error', text: 'Comment group already exists for this class/stream.', icon: 'error' });
    //       return;
    //     }

    //     if (response.status == 201) {
    //       this.fetchCommentGroups(); // Refresh the comment groups list
    //       this.$bvModal.hide("add-comment-group");
    //       this.resetData();
    //       this.$swal({ title: 'Success', text: 'New Comment Group Added!', icon: 'success' });
    //     } else {
    //       this.$swal({ title: 'Error', text: response.data.error, icon: 'error' });
    //     }
    //   } catch (error) {
    //     this.$swal({ title: 'Error', text: 'Failed to add comment group. Please try again.', icon: 'error' });
    //   }

    // },
    async addCommentGroup() {
      const formData = new FormData();

      if (this.signature) {
        formData.append("signature", this.signature);
      }

      formData.append("school_class", this.school_class.id);
      formData.append("status", this.selectedButton);

      if (
        this.selectedButton == 1 &&
        this.class_stream &&
        this.class_stream.id
      ) {
        formData.append("stream", this.class_stream.id);
      }

      const comments = [
        ...(this.start_1 !== "" && this.end_1 !== ""
          ? [
              {
                start_agg: Number(this.start_1),
                end_agg: Number(this.end_1),
                comment: this.comment_1,
              },
            ]
          : []),
        ...(this.start_2 !== "" && this.end_2 !== ""
          ? [
              {
                start_agg: Number(this.start_2),
                end_agg: Number(this.end_2),
                comment: this.comment_2,
              },
            ]
          : []),
        ...(this.start_3 !== "" && this.end_3 !== ""
          ? [
              {
                start_agg: Number(this.start_3),
                end_agg: Number(this.end_3),
                comment: this.comment_3,
              },
            ]
          : []),
        ...(this.start_4 !== "" && this.end_4 !== ""
          ? [
              {
                start_agg: Number(this.start_4),
                end_agg: Number(this.end_4),
                comment: this.comment_4,
              },
            ]
          : []),
        ...(this.start_5 !== "" && this.end_5 !== ""
          ? [
              {
                start_agg: Number(this.start_5),
                end_agg: Number(this.end_5),
                comment: this.comment_5,
              },
            ]
          : []),
        ...(this.comment_6
          ? [{ start_agg: 0, end_agg: 0, comment: this.comment_6 }]
          : []),
      ];

      // Append as array
      comments.forEach((comment, index) => {
        formData.append(`comments[${index}][start_agg]`, comment.start_agg);
        formData.append(`comments[${index}][end_agg]`, comment.end_agg);
        formData.append(`comments[${index}][comment]`, comment.comment);
      });

      try {
        const response = await axios.post("/add-comment-group", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });

        if (response.status == 201) {
          this.fetchCommentGroups();
          this.$bvModal.hide("add-comment-group");
          this.resetData();
          this.$swal({
            title: "Success",
            text: "New Comment Group Added!",
            icon: "success",
          });
        } else if (response.status == 409) {
          this.$swal({
            title: "Error",
            text: "Comment group already exists.",
            icon: "error",
          });
        }
      } catch (error) {
        this.$swal({
          title: "Error",
          text: "Failed to add comment group.",
          icon: "error",
        });
      }
    },
    async editCommentGroup() {
      if (!this.validateAdminTab1() || !this.validateAdminTab2()) {
        return; // Validation failed, do not proceed
      }

      const obj = {
        id: this.id,
        school_class: this.school_class.id,
        ...(this.selectedButton == 1 &&
        this.class_stream &&
        this.class_stream.id
          ? { stream: this.class_stream.id }
          : {}),
        status: this.selectedButton,
        comments: [
          ...(this.start_1 !== "" && this.end_1 !== ""
            ? [
                {
                  start_agg: Number(this.start_1),
                  end_agg: Number(this.end_1),
                  comment: this.comment_1,
                },
              ]
            : []),
          ...(this.start_2 !== "" && this.end_2 !== ""
            ? [
                {
                  start_agg: Number(this.start_2),
                  end_agg: Number(this.end_2),
                  comment: this.comment_2,
                },
              ]
            : []),
          ...(this.start_3 !== "" && this.end_3 !== ""
            ? [
                {
                  start_agg: Number(this.start_3),
                  end_agg: Number(this.end_3),
                  comment: this.comment_3,
                },
              ]
            : []),
          ...(this.start_4 !== "" && this.end_4 !== ""
            ? [
                {
                  start_agg: Number(this.start_4),
                  end_agg: Number(this.end_4),
                  comment: this.comment_4,
                },
              ]
            : []),
          ...(this.start_5 !== "" && this.end_5 !== ""
            ? [
                {
                  start_agg: Number(this.start_5),
                  end_agg: Number(this.end_5),
                  comment: this.comment_5,
                },
              ]
            : []),
          ...(this.comment_6
            ? [{ start_agg: 0, end_agg: 0, comment: this.comment_6 }]
            : []),
        ],
      };

      try {
        const response = await axios.post("/update-comment-group", obj);

        if (response.status == 200) {
          this.fetchCommentGroups(); // Refresh the comment groups list
          this.$bvModal.hide("add-comment-group");
          this.resetData();
          this.$swal({
            title: "Success",
            text: "Comment Group Updated!",
            icon: "success",
          });
        } else {
          this.$swal({
            title: "Error",
            text: response.data.error,
            icon: "error",
          });
        }
      } catch (error) {
        this.$swal({
          title: "Error",
          text: "Failed to update comment group. Please try again.",
          icon: "error",
        });
      }
    },

    confirmDeleteCommentGroup() {
      const obj = {
        id: this.id,
      };
      axios
        .post(`/delete-comment-group/`, obj)
        .then((response) => {
          if (response.status == 200) {
            this.fetchCommentGroups(); // Refresh the comment groups list
            this.$bvModal.hide("delete-comment-group");
            this.$swal({
              title: "Success",
              text: "Comment Group Deleted!",
              icon: "success",
            });
          } else {
            this.$swal({
              title: "Error",
              text: response.data.error,
              icon: "error",
            });
          }
        })
        .catch(() => {
          this.$swal({
            title: "Error",
            text: "Failed to delete comment group. Please try again.",
            icon: "error",
          });
        });
    },

    resetData() {
      this.school_class = null;
      this.class_stream = null;
      this.start_1 = 4;
      this.start_2 = "";
      this.start_3 = "";
      this.start_4 = "";
      this.start_5 = "";
      this.end_1 = "";
      this.end_2 = "";
      this.end_3 = "";
      this.end_4 = "";
      this.end_5 = "";
      this.comment_1 = "";
      this.comment_2 = "";
      this.comment_3 = "";
      this.comment_4 = "";
      this.comment_5 = "";
      this.comment_6 = "";
    },

    handleImage(e) {
      this.signature = e.target.files[0];
    },
    view(item) {
      const fileUrl = this.getFiles(item.signature);
      window.open(fileUrl, "_blank");
    },
  },
};
</script>

<style></style>
